/**
 * Generates a correlation ID by combining the current timestamp with a random string.
 * This can be used to link the backend lambda logs with the corresponding frontend session
 * @returns The generated correlation ID.
 */
export const generateId = (prefix = '') => {
  const randomChars = 'ghijklmnopqrstuv';
  let randomHex = '';

  for (let i = 0; i < 6; i++) {
    randomHex += randomChars[Math.floor(Math.random() * randomChars.length)];
  }

  return `${prefix}${Date.now()}${randomHex}`;
};

const SESSION_STORAGE_KEY = 'correlation-id';

/** Retrieve a correlation ID from session-storage or generate one if necessary */
export const getOrGenerateId = (prefix?: string) => {
  let id = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

  if (id) {
    return id;
  }

  id = generateId(prefix);
  saveId(id);
  return id;
};

/** Save a correlation ID to session-storage. */
export const saveId = (id: string) => {
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, id);
};